module.exports = __webpack_public_path__ + "nl.4daecacb.svg";